/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Region_AfricaInputs */

const bn_region_africa = /** @type {(inputs: Region_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আফ্রিকা`)
};

const de_region_africa = /** @type {(inputs: Region_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrika`)
};

const el_region_africa = /** @type {(inputs: Region_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αφρική`)
};

const en_region_africa = /** @type {(inputs: Region_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Africa`)
};

const es_region_africa = /** @type {(inputs: Region_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`África`)
};

const fr_region_africa = /** @type {(inputs: Region_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrique`)
};

const hi_region_africa = /** @type {(inputs: Region_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अफ़्रीका`)
};

const hu_region_africa = /** @type {(inputs: Region_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrika`)
};

const id_region_africa = /** @type {(inputs: Region_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrika`)
};

const it_region_africa = /** @type {(inputs: Region_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Africa`)
};

const ja_region_africa = /** @type {(inputs: Region_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アフリカ`)
};

const ko_region_africa = /** @type {(inputs: Region_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아프리카`)
};

const nl_region_africa = /** @type {(inputs: Region_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrika`)
};

const pl_region_africa = /** @type {(inputs: Region_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afryka`)
};

const pt_region_africa = /** @type {(inputs: Region_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`África`)
};

const ru_region_africa = /** @type {(inputs: Region_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Африка`)
};

const sv_region_africa = /** @type {(inputs: Region_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrika`)
};

const tr_region_africa = /** @type {(inputs: Region_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrika`)
};

const uk_region_africa = /** @type {(inputs: Region_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Африка`)
};

const vi_region_africa = /** @type {(inputs: Region_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Châu phi`)
};

const zh_region_africa = /** @type {(inputs: Region_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`非洲`)
};

const zh_hant_region_africa = /** @type {(inputs: Region_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`非洲`)
};

/**
* | output |
* | --- |
* | "Africa" |
*
* @param {Region_AfricaInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const region_africa = /** @type {((inputs?: Region_AfricaInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Region_AfricaInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_region_africa(inputs)
	if (locale === "de") return de_region_africa(inputs)
	if (locale === "el") return el_region_africa(inputs)
	if (locale === "en") return en_region_africa(inputs)
	if (locale === "es") return es_region_africa(inputs)
	if (locale === "fr") return fr_region_africa(inputs)
	if (locale === "hi") return hi_region_africa(inputs)
	if (locale === "hu") return hu_region_africa(inputs)
	if (locale === "id") return id_region_africa(inputs)
	if (locale === "it") return it_region_africa(inputs)
	if (locale === "ja") return ja_region_africa(inputs)
	if (locale === "ko") return ko_region_africa(inputs)
	if (locale === "nl") return nl_region_africa(inputs)
	if (locale === "pl") return pl_region_africa(inputs)
	if (locale === "pt") return pt_region_africa(inputs)
	if (locale === "ru") return ru_region_africa(inputs)
	if (locale === "sv") return sv_region_africa(inputs)
	if (locale === "tr") return tr_region_africa(inputs)
	if (locale === "uk") return uk_region_africa(inputs)
	if (locale === "vi") return vi_region_africa(inputs)
	if (locale === "zh") return zh_region_africa(inputs)
	return zh_hant_region_africa(inputs)
});